<template>
  <div id="contenedor-contrato-gastos-desktop">
    <v-data-table
      :headers="headers"
      :items="listado">
      <template
        v-slot:[`item.fechaDel`]="{ item }">
        <!-- {{ new Date(`${item.fechaDel} 00:00:0`).toLocaleDateString() }} -->
        {{ $moment(item.fechaDel).format('D/M/YYYY') }}
      </template>
      <template
        v-slot:[`item.fechaAl`]="{ item }">
        <!-- {{ new Date(`${item.fechaAl} 00:00:0`).toLocaleDateString() }} -->
        {{ $moment(item.fechaAl).format('D/M/YYYY') }}
      </template>
      <template
        v-slot:[`item.total`]="{ item }">
        {{ item.total | currency }}
      </template>
      <template
        v-slot:[`item.solicitudPago`]="{ item }">
        <estatus-pago
        :solicitud="mixGetSolicitud(item)">
      </estatus-pago>
      </template>
      <template
        v-slot:[`item.createdAt`]="{ item }">
        <fecha-humano
          :fecha="item.createdAt">
        </fecha-humano>
      </template>
      <template v-if="!soloLectura" v-slot:[`item.acciones`]="{ item }">
        <v-row>
          <registrar-remover-pago
            :referencia="item"
            :solicitudPago="mixGetSolicitudDetalles(item)"
          >
          </registrar-remover-pago>
          <v-tooltip
        v-if="mixValidaScopesActions(2)"
        top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="editar(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Editar</span>
        </v-tooltip>
        <v-tooltip
        v-if="mixValidaScopesActions(3)"
        top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="borrar(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>Borrar</span>
        </v-tooltip>
        </v-row>
      </template>
      <template
        v-slot:[`body.append`]="{ headers }">
        <table-footer-sumar-totales
          :registros="listado"
          :headers="headers">
        </table-footer-sumar-totales>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import mixRegistrarRemoverPago from '@/components/administracion/pagos/solicitudes/mixRegistrarRemoverPago';
import RegistrarRemoverPago from '@/components/administracion/pagos/solicitudes/RegistrarRemoverPago.vue';
import FechaHumano from '@/components/FechaHumano.vue';
import eventBus from '@/helpers/eventBus';
import TableFooterSumarTotales from '@/components/TableFooterSumaTotales.vue';
import EstatusPago from '@/components/administracion/pagos/EstatusPago.vue';

export default {
  name: 'contratoGastosDesktop',
  mixins: [mixRegistrarRemoverPago],
  components: {
    FechaHumano,
    TableFooterSumarTotales,
    EstatusPago,
    RegistrarRemoverPago,
  },
  props: {
    listado: {
      type: Array,
      required: true,
    },
    soloLectura: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      headers: [
        {
          text: 'Número',
          align: 'start',
          sortable: false,
          value: 'numero',
        },
        { text: 'Fecha Del', value: 'fechaDel' },
        { text: 'Fechal Al', value: 'fechaAl' },
        {
          text: 'Monto', value: 'total', align: 'end', seSuma: true,
        },
        { text: 'Comentarios', value: 'comentarios' },
        {
          text: 'Pagado', value: 'solicitudPago', align: 'center', sortable: false,
        },
        { text: 'F. Registro', value: 'createdAt' },
        {
          text: '',
          align: 'end',
          width: '150',
          value: 'acciones',
        },
      ],
    };
  },
  methods: {
    editar(gasto) {
      eventBus.$emit('editar-contrato-gasto', gasto);
    },
    borrar(gasto) {
      eventBus.$emit('eliminar-contrato-gasto', gasto);
    },
  },
};
</script>

<style lang="scss">

</style>
